module.exports = __webpack_public_path__ + "static/f3-19afd874c0faadcc99dea2f855366741.png";